
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.25 9.5v9a1.5 1.5 0 01-1.5 1.5H2.25a1.5 1.5 0 01-1.5-1.5v-9A1.5 1.5 0 012.25 8H4.5a.75.75 0 010 1.5H2.25v9h13.5v-9H13.5a.75.75 0 110-1.5h2.25a1.5 1.5 0 011.5 1.5zM5.78 5.53l2.47-2.47v8.69a.75.75 0 101.5 0V3.06l2.47 2.47a.75.75 0 101.06-1.06L9.53.72a.75.75 0 00-1.06 0L4.72 4.47a.75.75 0 101.06 1.06z","fill":"#000"}})])
          )
        }
      }
    